export const PAGE_SIZE = 10;

/** @deprecated */
export const SNACKBAR_SUCCESS_MESSAGE = 'SNACKBAR_SUCCESS_MESSAGE';

/** @deprecated */
export const SNACKBAR_ERROR_MESSAGE = 'SNACKBAR_ERROR_MESSAGE';
